import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home.vue'
import WhyChoose from '../components/WhyChoose.vue'
import MediaNews from '../components/MediaNews.vue'
import MediaDetail from '../components/MediaDetail.vue'
import DownloadPage from '../components/Download.vue'
import Help from '../components/Help.vue'
import StockInvestment from '../components/StockInvestment.vue'
import FundInvestment from '../components/FundInvestment.vue'
import InsuranceInvestment from '../components/InsuranceInvestment.vue'
import AccountDelegate from '../components/AccountDelegate.vue'
import AccountDelegatePage from '../components/AccountDelegatePage.vue'
import StockCustomers from '../components/StockCustomers.vue'
import FundCustomers from '../components/FundCustomers.vue'
import DelegateCustomers from '../components/DelegateCustomers.vue'
import InsuranceCustomers from '../components/InsuranceCustomers.vue'
import Announcements from '../components/Announcements.vue'
import JoinUs from '../components/JoinUs.vue'
import Pricing from '../components/Pricing.vue'
import Disclaimer from '../components/Disclaimer.vue'
import TermsOfService from '../components/TermsOfService.vue'
import PrivacyPolicy from '../components/PrivacyPolicy.vue'
import AboutUs from '../components/AboutUs.vue'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/why',
      name: 'WhyChoose',
      component: WhyChoose
    },
    {
      path: '/media',
      name: 'MediaNews',
      component: MediaNews
    },
    {
      path: '/media/:id',
      name: 'MediaDetail',
      component: MediaDetail
    },
    {
      path: '/download',
      name: 'Download',
      component: DownloadPage
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/stock-investment',
      name: 'StockInvestment',
      component: StockInvestment
    },
    {
      path: '/stock-customers',
      name: 'StockCustomers',
      component: StockCustomers
    },
    {
      path: '/fund-customers',
      name: 'FundCustomers',
      component: FundCustomers
    },
    {
      path: '/delegate-customers',
      name: 'DelegateCustomers',
      component: DelegateCustomers
    },
    {
      path: '/insurance-customers',
      name: 'InsuranceCustomers',
      component: InsuranceCustomers
    },
    {
      path: '/fund-investment',
      name: 'FundInvestment',
      component: FundInvestment
    },
    {
      path: '/insurance-investment',
      name: 'InsuranceInvestment',
      component: InsuranceInvestment
    },
    {
      path: '/account-delegate',
      name: 'AccountDelegate',
      component: AccountDelegate
    },
    {
      path: '/account-delegate-full',
      name: 'AccountDelegatePage',
      component: AccountDelegatePage
    },
    {
      path: '/announcements',
      name: 'Announcements',
      component: Announcements
    },
    {
      path: '/join-us',
      name: 'JoinUs',
      component: JoinUs
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing
    },
    {
      path: '/disclaimer',
      name: 'Disclaimer',
      component: Disclaimer
    },
    {
      path: '/terms',
      name: 'TermsOfService',
      component: TermsOfService
    },
    {
      path: '/privacy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/about',
      name: 'AboutUs',
      component: AboutUs
    }
  ]
})

// 路由跳转后滚动到页面顶部
router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router
